<template lang="html">
  <div>
    <div v-if="isLoading" class="text-xs-center loadingClass">
      <v-progress-circular :size="70" :width="5" indeterminate color="primary"></v-progress-circular>
    </div>
    <h1 style="text-align:center; font-size:2.3em;" class="mt-5">ผลคะแนนวาระการประชุมครั้งที่ {{termYear.term}} ปี {{termYear.year}}</h1>
    <v-data-table :headers="headers" :items="agendaInfo" class="elevation-1 mb-5" :rows-per-page-items="[8,15,25,{'text':'All','value':-1}]">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.agenda }}</td>
        <td class="text-xs-left">{{ props.item.title }}</td>
        <td class="justify-center layout px-0">
          <v-btn small round outline color="primary" :disabled="props.item.calculatetype === 1" @click="fillScore(props.item)">กรอกคะแนน</v-btn>
          <v-btn small round outline color="secondary" @click="calculate(props.item)">คำนวณคะแนน</v-btn>
        </td>
      </template>
      <template slot="no-data">
        <v-btn color="primary" @click="getAgendaInYear('', '')">Reset</v-btn>
      </template>
      <template slot="pageText" slot-scope="props">
        {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="headline">บันทึกคะแนน</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="เห็นด้วย" type="number" min="0" v-model="agendaScore.accept" disabled></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="ไม่เห็นด้วย" type="number" min="0" v-model="agendaScore.noaccept"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="งดออกเสียง" type="number" min="0" v-model="agendaScore.abstain"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="บัตรเสีย" type="number" min="0" v-model="agendaScore.broke"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showResultDialog" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="headline">ผลการคำนวณคะแนน</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs5 offset-xs1>
                <span>เห็นด้วย :</span>
              </v-flex>
              <v-flex xs5 class="text-right">
                <span>{{setQShare(agendaScore.accept)}}</span>
              </v-flex>
              <v-flex xs5 offset-xs1>
                <span>ไม่เห็นด้วย :</span>
              </v-flex>
              <v-flex xs5 class="text-right">
                <span>{{setQShare(agendaScore.noaccept)}}</span>
              </v-flex>
              <v-flex xs5 offset-xs1>
                <span>งดออกเสียง :</span>
              </v-flex>
              <v-flex xs5 class="text-right">
                <span>{{setQShare(agendaScore.abstain)}}</span>
              </v-flex>
              <v-flex xs5 offset-xs1>
                <span>บัตรเสีย :</span>
              </v-flex>
              <v-flex xs5 class="text-right">
                <span>{{setQShare(agendaScore.broke)}}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      dialog: false,
      showResultDialog: false,
      headers: [
        {
          text: 'วาระที่',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'ชื่อวาระ', value: 'agendaname', sortable: false },
        { text: 'Actions', value: 'name', sortable: false }
      ],
      agendaInfo: [],
      agendaScore: {
        accept: '',
        noaccept: '',
        abstain: '',
        broke: ''
      },
      selectedAgenda: {},
      isLoading: false
    }
  },
  computed: {
    userData () {
      if (this.$cookies.isKey('shareholder_information')) {
        return JSON.parse(Decode.decode(this.$cookies.get('shareholder_information')))
      } else {
        return ''
      }
    },
    termYear () {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(Decode.decode(this.$cookies.get('shareholder_termyear')))
      } else {
        return ''
      }
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    this.getAgendaInYear('', '')
  },
  methods: {
    getAgendaInYear (type, agendaId) {
      this.axios.get(process.env.API + '/getAllAgendaScore/' + this.termYear.term + '/' + this.termYear.year).then((response) => {
        if (response.data.status === 'success') {
          this.agendaInfo = response.data.info
          if (type === 'showscore' && agendaId !== '') {
            for (var i = 0; i < this.agendaInfo.length; i++) {
              if (this.agendaInfo[i]['agenda_id'] === agendaId) {
                this.showScore(this.agendaInfo[i])
              }
            }
          }
        }
      })
    },
    calculate (item) {
      var me = this
      this.$swal({
        title: 'คุณต้องการคำนวณคะแนน ?',
        text: 'คุณต้องการคำนวณคะแนนของวาระที่ ' + item.agenda + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then(function () {
        if (me.isLoading) return
        me.isLoading = true
        var source = { term: me.termYear.term, year: me.termYear.year, agenda_id: item.agenda_id, createby: me.userData.username }
        me.axios.post(process.env.API + '/calculateScore', source).then((response) => {
          var result = response.data
          if (result.status === 'fail' && result.message === 'Dont have any result from this agenda in submit table') {
            me.$swal('ไม่สามารถคำนวณคะแนนได้', 'คุณไม่ได้ทำการกรอกข้อมูลการลงคะแนนสำหรับวาระนี้ไว้ล่วงหน้า', 'error')
            me.isLoading = false
          } else if (result.status === 'fail' && result.message === 'Dont have this agenda in agenda table') {
            me.$swal('ไม่พบวาระการประชุมนี้', '', 'error')
            me.isLoading = false
          } else if (result.status === 'success') {
            me.getAgendaInYear('showscore', item.agenda_id)
            me.close()
            this.$socket.emit('setPresentation')
          }
        })
      })
    },
    fillScore (item) {
      this.selectedAgenda = item
      if (item.scoreInfo.length > 0) {
        this.agendaScore.accept = item.scoreInfo[0].accept
        this.agendaScore.noaccept = item.scoreInfo[0].noaccept
        this.agendaScore.abstain = item.scoreInfo[0].abstain
        this.agendaScore.broke = item.scoreInfo[0].broke
      }
      this.dialog = true
    },
    showScore (item) {
      if (item.scoreInfo.length > 0) {
        this.agendaScore.accept = item.scoreInfo[0].accept
        this.agendaScore.noaccept = item.scoreInfo[0].noaccept
        this.agendaScore.abstain = item.scoreInfo[0].abstain
        this.agendaScore.broke = item.scoreInfo[0].broke
      }
      this.showResultDialog = true
      this.isLoading = false
    },
    close () {
      this.dialog = false
      this.showResultDialog = false
      this.agendaScore.accept = ''
      this.agendaScore.noaccept = ''
      this.agendaScore.abstain = ''
      this.agendaScore.broke = ''
    },
    save () {
      var source = { term: this.termYear.term, year: this.termYear.year, agenda_id: this.selectedAgenda.agenda_id, score: this.agendaScore, createby: this.userData.username }
      this.axios.post(process.env.API + '/submitScore', source).then((response) => {
        var result = response.data
        if (result.status === 'fail' && result.message === 'Dont have this agenda in agenda table') {
          this.$swal('ไม่พบวาระการประชุมนี้', '', 'error')
        } else if (result.status === 'fail' && result.message === 'This agenda cannot submit score type') {
          this.$swal('ประเภทการคำนวณคะแนนไม่ถูกต้อง', 'คุณไม่สามารถกรอกคะแนนจากประเภทการคำนวณคะแนนนี้ได้', 'error')
        } else if (result === 'success') {
          this.$swal('บันทึกคะแนนเรียบร้อย', '', 'success')
        } else {
          this.$swal('พบข้อผิดพลาด', 'กรุณาติดต่อเจ้าหน้าที่', 'error')
        }
        this.getAgendaInYear('', '')
        this.close()
        this.$socket.emit('setPresentation')
      })
    },
    setQShare (number) {
      return number.toLocaleString(undefined, { minimumFractionDigits: 0 })
    }
  }
}
</script>

<style lang="css" scoped>
.elevation-1{
  margin: 15px;
}
td{
  margin-top: 5px;
}
.loadingClass{
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 70vh;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/CalculateScore.vue